import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { ReachStep } from './components/ReachStep';

async function loadReachStep(): Promise<typeof ReachStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-reach" */ './components/ReachStep'))
		.ReachStep;
}

export const ReachLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadReachStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadReachStep = loadReachStep;
